import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { host_url } from '../../App';
import KernteamLayout from '../../KernteamLayout';
import BackArrow from '../../BackArrow';
import './DisplaySteuerung.css';

const DisplaySteuerung = () => {
    const [einheiten, setEinheiten] = useState([]);
    const [settings, setSettings] = useState({ showEinheit: false, einheitId: null, manualOverride: false, showCustom: false, customText: '', customTime: '', showBlack: false });
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    // Local state for inputs
    const [customText, setCustomText] = useState('');
    const [customTime, setCustomTime] = useState('');

    useEffect(() => {
        fetchEinheiten();
        fetchSettings();
    }, []);

    useEffect(() => {
        if (settings.customText) setCustomText(settings.customText);
        if (settings.customTime) setCustomTime(settings.customTime);
    }, [settings.customText, settings.customTime]);

    const fetchEinheiten = async () => {
        try {
            const response = await axios.get(`${host_url}/einheiten_mit_zeiten`);
            setEinheiten(response.data);
        } catch (err) {
            console.error('Fehler beim Laden der Einheiten:', err);
            setError('Fehler beim Laden der Einheiten');
        }
    };

    const fetchSettings = async () => {
        try {
            const response = await axios.get(`${host_url}/display_settings`);
            setSettings(response.data);
        } catch (err) {
            console.error('Fehler beim Laden der Einstellungen:', err);
        }
    };

    const updateSettings = async (newSettings) => {
        try {
            // If changing mode or unit, manualOverride is implicitly true
            const settingsToSend = { ...newSettings, manualOverride: true };
            const response = await axios.put(`${host_url}/display_settings`, settingsToSend);
            setSettings(response.data.settings);
            setMessage('Einstellungen manuell überschrieben!');
            setTimeout(() => setMessage(''), 3000);
        } catch (err) {
            console.error('Fehler beim Speichern:', err);
            setError('Fehler beim Speichern der Einstellungen');
            setTimeout(() => setError(''), 3000);
        }
    };

    const resetToAuto = async () => {
        try {
            const response = await axios.put(`${host_url}/display_settings`, { manualOverride: false });
            setSettings(response.data.settings);
            setMessage('Automatik-Modus aktiviert!');
            setTimeout(() => setMessage(''), 3000);
        } catch (err) {
            console.error('Fehler beim Zurücksetzen:', err);
            setError('Fehler beim Aktivieren der Automatik');
        }
    };

    const handleEinheitChange = (e) => {
        const einheitId = e.target.value ? parseInt(e.target.value) : null;
        updateSettings({ ...settings, einheitId });
    };

    const activateCustomMode = () => {
        updateSettings({
            ...settings,
            showEinheit: false,
            showCustom: true,
            showBlack: false,
            customText,
            customTime
        });
    };

    const activateUnitMode = () => {
        updateSettings({
            ...settings,
            showEinheit: true,
            showCustom: false,
            showBlack: false
        });
    }

    const activateCountdownMode = () => {
        updateSettings({
            ...settings,
            showEinheit: false,
            showCustom: false,
            showBlack: false
        });
    }

    const activateBlackMode = () => {
        updateSettings({
            ...settings,
            showEinheit: false,
            showCustom: false,
            showBlack: true
        });
    }

    const formatDate = (dateStr) => {
        return new Date(dateStr).toLocaleDateString('de-DE', {
            weekday: 'short',
            day: '2-digit',
            month: '2-digit'
        });
    };

    const formatTime = (timeStr) => {
        if (!timeStr) return '';
        return timeStr.substring(0, 5);
    };

    const selectedEinheit = einheiten.find(e => e.ID === settings.einheitId);

    return (
        <KernteamLayout>
            <div className="container display-steuerung">
                <BackArrow to="/listen" />
                <h1 className="section-title blue">Display-Steuerung</h1>
                <p className="description">
                    Steuere hier, was auf dem TV-Display angezeigt wird.
                </p>

                {error && <p className="error-message">{error}</p>}
                {message && <p className="success-message">{message}</p>}

                <div className="settings-card auto-status-card">
                    <h4>Betriebsmodus</h4>
                    <div className="status-display">
                        Status: <strong>{settings.manualOverride ? 'Manuelle Steuerung' : 'Automatik'}</strong>
                    </div>
                    {settings.manualOverride && (
                        <button className="reset-btn" onClick={resetToAuto}>
                            <span className="material-symbols-outlined">autorenew</span>
                            Automatik wieder einschalten
                        </button>
                    )}
                    <p className="mode-description">
                        Im Automatik-Modus zeigt das Display 15 Min. vor Beginn der Einheit die Zuteilungen an,
                        und 15 Min. vor Ende wechselt es zurück zum Countdown.
                        Zwischen 22:15 und 7:30 Uhr zeigt das Display einen Blackscreen (Nachtruhe).
                    </p>
                </div>

                <div className={`settings-card ${!settings.manualOverride ? 'disabled-card' : ''}`}>
                    <h4>Manuelle Steuerung</h4>
                    <div className="mode-toggle">
                        <button
                            className={`mode-btn ${!settings.showEinheit && !settings.showCustom && !settings.showBlack ? 'active' : ''}`}
                            onClick={activateCountdownMode}
                            disabled={!settings.manualOverride && false}
                        >
                            <span className="material-symbols-outlined">schedule</span>
                            Countdown
                        </button>
                        <button
                            className={`mode-btn ${settings.showCustom ? 'active' : ''}`}
                            onClick={activateCustomMode}
                            disabled={!settings.manualOverride && false}
                        >
                            <span className="material-symbols-outlined">edit_note</span>
                            Freitext
                        </button>
                        <button
                            className={`mode-btn ${settings.showEinheit ? 'active' : ''}`}
                            onClick={activateUnitMode}
                            disabled={!settings.manualOverride && false}
                        >
                            <span className="material-symbols-outlined">view_list</span>
                            Einheit
                        </button>
                        <button
                            className={`mode-btn ${settings.showBlack ? 'active' : ''}`}
                            onClick={activateBlackMode}
                            disabled={!settings.manualOverride && false}
                        >
                            <span className="material-symbols-outlined">dark_mode</span>
                            Blackscreen
                        </button>
                    </div>

                    {settings.showCustom && (
                        <div className="custom-mode-container">
                            <h4>Freitext Einstellungen</h4>
                            <div className="input-group">
                                <label>Titel / Text:</label>
                                <input
                                    type="text"
                                    value={customText}
                                    onChange={(e) => setCustomText(e.target.value)}
                                    placeholder="z.B. Stadtstunde"
                                />
                            </div>
                            <div className="input-group">
                                <label>Zielzeit (optional):</label>
                                <input
                                    type="time"
                                    value={customTime}
                                    onChange={(e) => setCustomTime(e.target.value)}
                                />
                            </div>
                            <button className="save-custom-btn" onClick={activateCustomMode}>
                                <span className="material-symbols-outlined">save</span>
                                Anwenden
                            </button>
                        </div>
                    )}

                    {settings.showEinheit && (
                        <div className="einheit-selection-container">
                            <h4>Einheit auswählen</h4>
                            <select
                                value={settings.einheitId || ''}
                                onChange={handleEinheitChange}
                                className="einheit-select"
                            >
                                <option value="">-- Einheit wählen --</option>
                                {/* Removed .filter(e => e.Aktiv) to show ALL units */}
                                {einheiten.map(einheit => (
                                    <option key={einheit.ID} value={einheit.ID}>
                                        {einheit.Name} ({formatDate(einheit.Datum)}, {formatTime(einheit.Start)} - {formatTime(einheit.Ende)})
                                    </option>
                                ))}
                            </select>

                            {selectedEinheit && (
                                <div className="selected-info">
                                    <strong>Ausgewählt:</strong> {selectedEinheit.Name}
                                </div>
                            )}
                        </div>
                    )}
                </div>

                <div className="settings-card preview-card">
                    <h4>Vorschau</h4>
                    <a
                        href="/jobs"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="preview-link"
                    >
                        <span className="material-symbols-outlined">open_in_new</span>
                        Display-Seite in neuem Tab öffnen
                    </a>
                </div>
            </div>
        </KernteamLayout>
    );
};

export default DisplaySteuerung;
